import Api from '../../../api/article/testPigApi'

export default {
  namespaced: true,
  state: {
    testPigs: []
  },
  mutations: {
    setTestPigs(state, data) {
      state.testPigs = data;
    }
  },
  actions: {
    create(context, {testPig}) {
      return new Promise((resolve, reject) => {
        Api.create(testPig).then(response =>  {
          context.dispatch('NOTIFY_MSG', 'article.notification.save',
            { root: true});
          resolve(response.data);
        }).catch(error => {
          context.dispatch('NOTIFY_ERROR', error, { root: true});
          reject(error);
        });
      })
    },
    createFromCarcase(context, form) {
      return new Promise((resolve, reject) => {
        Api.createFromCarcase(form).then(response =>  {
          context.dispatch('NOTIFY_MSG', 'article.notification.save',
            { root: true});
          resolve(response.data);
        }).catch(error => {
          context.dispatch('NOTIFY_ERROR', error, { root: true});
          reject(error);
        });
      })
    },
    update(context, {testPig}) {
      return new Promise((resolve, reject) => {
        Api.update(testPig.id, testPig).then(response =>  {
          context.dispatch('NOTIFY_MSG', 'article.notification.save',
            { root: true}).then();
          resolve(response.data);
        }).catch(error => {
          context.dispatch('NOTIFY_ERROR', error, { root: true}).then();
          reject(error);
        });
      })
    },
    delete(context, {id}) {
      return new Promise((resolve, reject) => {
        Api.delete(id).then(response =>  {
          context.dispatch('NOTIFY_MSG', 'article.notification.save',
            { root: true}).then();
          resolve(response.data);
        }).catch(error => {
          context.dispatch('NOTIFY_ERROR', error, { root: true}).then();
          reject(error);
        });
      })
    },
    async fetch({dispatch, commit}) {
      try {
        const response = await Api.fetch();
        commit('setTestPigs', response.data);
        return Promise.resolve();
      } catch(error) {
        await dispatch('NOTIFY_ERROR', error, { root: true});
        return Promise.reject();
      }
    }
  }
}
